import { useState } from "react";
import "../styles/qualification.css";

const Qualifications = ({ theme }) => {
  const [toggleState, setToggleState] = useState(2);
  const toggleTab = (i) => {
    setToggleState(i);
  };
  return (
    <section className="qualification section" id={theme}>
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My personal journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button  button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>
            Education
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button  button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content "
            }
          >
            {/* <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Web Design</h3>
                <span className="qualification__subtitle">
                  Spain - Institute
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>
                  2021 - Present
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div> */}

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              
              <div>
                <h3 className="qualification__title">Web Development</h3>
                <span className="qualification__subtitle">
                  Gomycode Gabes - Institute
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>
                  {" "}
                  2022 
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Web Security</h3>
                <span className="qualification__subtitle">
                  Iset gabes - Institute
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>
                  {" "} 2018 - 2021
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Computer Science </h3>
                <span className="qualification__subtitle">
                  Waha chenneni - Institute
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>
                  {" "}2017 - 2018
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >

              <div className="qualification__data">
              <div></div>

              
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
                
              </div>
              <div>
                <h3 className="qualification__title">Web development</h3>
                <span className="qualification__subtitle">
                 Securas Technologies
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>
                  {" "}10-2024 -- 03-2025
                </div>
              </div>
            </div>

            <div className="qualification__data">
              
              <div>
                <h3 className="qualification__title">Web Development</h3>
                <span className="qualification__subtitle">
                  Gomycode - Gabes
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>{" "}
                  2022 
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
                
              </div>
              <div>
                <h3 className="qualification__title">Web development</h3>
                <span className="qualification__subtitle">
                  Pro-Tech - Gabes
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>
                  {" "}2020 - 2021
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">CCL</h3>
                <span className="qualification__subtitle">Télecom - Gabes</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i>
                  {" "} 2018 - 2019
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualifications;
